import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import { SxProps } from '@mui/material';
import { Box } from '@mui/system';
import { useAppSelector } from '@/utils/hook';
import { ILangObj } from '@/slices/goyoloSeo/sliceType';
import { ImagesSeo } from '@/slices/strapi/slices/strapiSlice';
import { loaderImageVex } from '@/utils/loadImageSeoVex';
import Image from 'next/image';

interface IBannerDiscount {
  isDesktop?: boolean;
  isRoutePage?: boolean;
  sx?: SxProps;
  isHiddenTitle?: boolean;
  vehicleType?: 'bus' | 'flight' | undefined;
  lang?: ILangObj;
  imagePromotion?: any,
}
// click banner moca open link  url: 'https://landingpage.vexere.com/uu-dai-vi-dien-tu-goyolo/'

function BannerDiscountVcms(props: IBannerDiscount) {
  const {
    isDesktop, sx, isHiddenTitle, isRoutePage, vehicleType, lang, imagePromotion,
  } = props;

  let images = [] as ImagesSeo[] | undefined;
  if (lang?.lang === 'en' && imagePromotion?.BANNER_IMAGE_SEO?.en) {
    images = imagePromotion?.BANNER_IMAGE_SEO?.en;
  } else {
    images = imagePromotion?.BANNER_IMAGE_SEO?.vi;
  }
  if (images?.length === 0) {
    return <></>;
  }
  const handlerClickBanner = (url?: string) => {
    if (url) window.open(url, '_blank');
  };

  return (
    <Stack
      sx={{
        gap: isDesktop ? '0px' : '16px',
        ...sx,
      }}
    >
      <Typography
        sx={{
          fontWeight: '700',
          fontSize: '24px',
          lineHeight: '32px',
          color: '',
          textAlign: isDesktop ? 'center' : 'left',
        }}
      >
        {lang?.global?.promotions || 'Chương trình giảm giá'}
      </Typography>
      {isDesktop && (
        <Stack
          direction="row"
          sx={{
            width: '100%',
            gap: '22px',
            justifyContent: 'space-between',
            alignItems: 'center',
            overflowX: 'auto',
            overflowY: 'auto',
          }}
        >
          {images?.map((image) => (
            <Box
              key={image.Source}
              style={{
                minWidth: '312px',
                minHeight: '221px',
              }}
              // onClick={() => handlerClickBanner(image?.Source)}
            >
              <Image
                loader={loaderImageVex}
                src={image.Source}
                alt="logo"
                width="312px"
                height="221px"
                objectFit="contain"
              />
            </Box>
          ))}
        </Stack>
      )}
      {!isDesktop && (
        <Stack
          direction="row"
          sx={{
            width: '100%',
            gap: '16px',
            justifyContent: 'flex-start',
            alignItems: 'center',
            overflow: 'auto !important',
          }}
        >
          {images?.map((image) => (
            <Box
              key={image.Source}
              // onClick={() => handlerClickBanner(image?.Source)}
              sx={{
                minWidth: '287px',
                minHeight: '143px',
              }}
            >
              <Image
                loader={loaderImageVex}
                src={image.Source}
                alt="logo"
                width="287px"
                height="143px"
              />
            </Box>
          ))}
        </Stack>
      )}
    </Stack>
  );
}

export default BannerDiscountVcms;
